import { pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';

/**
 * Configure the pdf.js worker URL once. Imported for side-effects by
 * `FactsheetModal` and `BrochureModal`. Pinned to the same worker version
 * the agent app uses (see `super-picker/components/siteplan/TopViewingSitePlanDetail.tsx`).
 */
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;
